<template>
  <div id="add-members-page" class="flex-display-body py-5" role="tabpanel" aria-labelledby="addMembers">
    <h2 class="pb-3 text-center">Add Members</h2>
    <!-- Person Members -->
    <add-person-members :response-name="pipelineResponseName('person')"></add-person-members>
    <!-- NON-Public Group Members -->
    <add-group-members :response-name="pipelineResponseName('group')"></add-group-members>
    <!-- Org (Public) Group Members-->
    <add-org-members :response-name="pipelineResponseName('org')"></add-org-members>
  </div>
</template>

<script>
import AddPersonMembers from './AddPersonMembers';
import AddGroupMembers from './AddGroupMembers';
import AddOrgMembers from './AddOrgMembers';

export default {
  title: 'Add Members',
  data() {
    return {
      pipelineResponses: [
        { key: 'person', responseName: 'addPersonMembersResponse' },
        { key: 'group', responseName: 'addGroupMembersResponse' },
        { key: 'org', responseName: 'addOrgMembersResponse' },
      ],
    };
  },
  methods: {
    pipelineResponseName(key) {
      const response = (this.pipelineResponses).find(resp => resp.key === key);
      return response.responseName;
    },
    resetPipelineResponses() {
      const vm = this;
      /* Clear the pipelined requests state for each card on this page. */
      this.pipelineResponses.forEach((response) => {
        vm.$store.dispatch('clearPipelinedStateResponse', response.responseName);
      });
    },
    track() {
      this.$gtag.pageview({
        page_title: 'Add Members',
        page_path: `/group/${this.$store.state.currentGroup.managedGroup.uugid}`,
      });
    },
  },
  activated() {
    this.resetPipelineResponses();
    this.track();
  },
  deactivated() {
    this.resetPipelineResponses();
  },
  components: {
    'add-person-members': AddPersonMembers,
    'add-group-members': AddGroupMembers,
    'add-org-members': AddOrgMembers,
  },
};
</script>

<style scoped>
  /* See https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors for use of >>> */
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> .card {
    margin-bottom: 2em;
    padding-bottom: .75em;
  }
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> .scroll-container {
    max-height: 400px;
    overflow-y: auto;
  }
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> form > .scroll-container {
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> .form-group {
    margin-bottom: 0.5rem;
  }
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> .vertical-center {
    margin: auto;
  }
  #add-members-page {
    -ms-word-break: normal;
    word-break: normal;
  }
  /* Applies styling in child component */
  /*noinspection CssUnusedSymbol*/
  #add-members-page >>> .group-uugid {
    -ms-word-break: break-all;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/add-members/AddMembers.vue